<template>
  
    <div>
      <a-row class="topichead">
        <a-row class="wrap"
          ></a-row>
      </a-row>
      <a-row class="topmenu">
        <a-row class="wrap">
          <ul class="zTmenulist">
            <li class="current">
             <router-link to="/" 
                >首页</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: '人大专题列表', params: { id: 1 } }"
                >会议动态</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: '人大专题列表', params: { id: 1 } }"
                >会议日程</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: '人大专题列表', params: { id: 1 } }"
                >会议议程</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: '人大专题列表', params: { id: 1 } }"
                >审议聚焦</router-link
              >
            </li>
            <li class="cd2">
              <router-link :to="{ name: '人大专题列表', params: { id: 1 } }"
                >审议聚焦</router-link
              >
            </li>
            <li class="cd3">
              <router-link :to="{ name: '人大专题列表', params: { id: 1 } }"
                >领导讲话</router-link
              >
            </li>
            <li class="cd3">
              <router-link :to="{ name: '人大专题列表', params: { id: 1 } }"
                >报告解读</router-link
              >
            </li>
            <li class="cd3">
              <router-link :to="{ name: '人大专题列表', params: { id: 1 } }"
                >代表之窗</router-link
              >
            </li>
            <li class="cd3">
              <router-link :to="{ name: '人大专题列表', params: { id: 1 } }"
                >参考资料</router-link
              >
            </li>
            <li class="cd3">
              <router-link :to="{ name: '人大专题列表', params: { id: 1 } }"
                >图说会议</router-link
              >
            </li>
            <li class="cd2 cd2">
              <router-link :to="{ name: '人大专题列表', params: { id: 1 } }"
                >大会组织机构</router-link
              >
            </li>
          </ul>
        </a-row>
      </a-row>
    </div>
 
</template>      
<script>
export default {
  name: "TopicHeader",
  props: {
    msg: String,
  },
};
</script>
<style lang="less" scoped>

.ant-layout-header {
  height: 230px !important;
}
</style>